function wrapIndex(index, count) {
	if (count <= 0) {
		return 0;
	}

	return ((index % count) + count) % count;
}

function getInitialCenterIndex(count) {
	if (count <= 1) {
		return 0;
	}

	return 1;
}

function updateSideCard(card, post) {
	if (!card) {
		return;
	}

	card.href = post?.url || '#';
	card.innerHTML = post
		? `${post.sideImage}<span class="case-studies-slider__card-title">${post.companyName || post.title}</span>`
		: '';
}

function updateFeaturedContent(slider, post) {
	const image = slider.querySelector(
		'.case-studies-slider__featured-image-media'
	);
	const metrics = slider.querySelector('.case-metrix');
	const kicker = slider.querySelector('.case-studies-slider__kicker');
	const link = slider.querySelector('.case-studies-slider__featured-link');

	if (image) {
		image.innerHTML = `<a class="case-studies-slider__featured-image-link" href="${
			post?.url || '#'
		}">${ post?.centerImage || '' }</a>`;
	}

	if (metrics) {
		const stats = [ post?.stat1 || '', post?.stat2 || '', post?.stat3 || '' ];

		metrics.innerHTML = stats
			.map(
				( stat ) => `<div class="case-metrix__item">${ stat }</div>`
			)
			.join('');
	}

	if (kicker) {
		kicker.textContent = post?.companyName || post?.title || '';
	}

	if (link) {
		link.href = post?.url || '#';
		link.textContent = post?.title || '';
	}
}

function replayStaggeredSection(section) {
	if (
		!section ||
		!section.matches('[data-component-list*="StaggeredFadeIn"]')
	) {
		return;
	}

	const items = [ ...section.children ].filter(
		( item ) =>
			! item.hasAttribute( 'hidden' ) &&
			! item.matches( '.case-studies-slider__featured-image-media' )
	);

	if ( ! items.length ) {
		return;
	}

	items.forEach( ( item, index ) => {
		item.setAttribute( 'data-staggered-item', '' );
		item.style.setProperty( '--stagger-index', index );
	} );

	section.classList.add( 'staggered-ready' );
	section.classList.remove('staggered-end');
	void section.offsetHeight;

	items.forEach( ( item ) => {
		item.style.transition = 'none';
		item.style.opacity = '0';
		item.style.transform = 'translateY(var(--staggered-translate-y))';
	} );
}

function replayCaseStudiesAnimations(slider) {
	[
		'.case-studies-slider__featured-image',
		'.case-studies-slider__featured-content',
	].forEach((selector) => {
		slider
			.querySelectorAll(selector)
			.forEach((section) => replayStaggeredSection(section));
	});
}

function hideCaseStudiesAnimations(slider) {
	[
		'.case-studies-slider__featured-image',
		'.case-studies-slider__featured-content',
	].forEach((selector) => {
		slider.querySelectorAll(selector).forEach((section) => {
			if (
				!section.matches('[data-component-list*="StaggeredFadeIn"]')
			) {
				return;
			}

			const items = [ ...section.children ].filter(
				( item ) =>
					! item.hasAttribute( 'hidden' ) &&
					! item.matches( '.case-studies-slider__featured-image-media' )
			);

			if ( ! items.length ) {
				return;
			}

			section.classList.add( 'staggered-ready' );
			section.classList.remove( 'staggered-end' );

			items.forEach( ( item, index ) => {
				item.setAttribute( 'data-staggered-item', '' );
				item.style.setProperty( '--stagger-index', index );
				item.style.transition = 'none';
				item.style.opacity = '0';
				item.style.transform = 'translateY(var(--staggered-translate-y))';
			} );
		});
	});
}

function renderCaseStudiesState(slider, posts, currentIndex) {
	if (!slider || !posts.length) {
		return currentIndex;
	}

	const leftIndex = wrapIndex(currentIndex - 1, posts.length);
	const rightIndex = wrapIndex(currentIndex + 1, posts.length);

	updateSideCard(
		slider.querySelector('.case-studies-slider__card--prev'),
		posts[leftIndex]
	);
	updateSideCard(
		slider.querySelector('.case-studies-slider__card--next'),
		posts[rightIndex]
	);
	updateFeaturedContent(slider, posts[currentIndex]);

	return currentIndex;
}

function animateCaseStudiesTransition(slider, posts, nextIndex) {
	if (!slider || slider.classList.contains('is-animating')) {
		return null;
	}

	const metricDelay = 300;

	hideCaseStudiesAnimations(slider);
	slider.classList.add('is-animating', 'is-metric-hidden');
	renderCaseStudiesState(slider, posts, nextIndex);

	window.setTimeout(() => {
		replayCaseStudiesAnimations(slider);
		slider.classList.add('is-metric-entering');

		window.requestAnimationFrame(() => {
			window.requestAnimationFrame(() => {
				slider.classList.remove('is-metric-hidden');

				window.setTimeout( () => {
					slider
						.querySelectorAll(
							'.case-studies-slider__featured-image, .case-studies-slider__featured-content'
						)
						.forEach( ( section ) => {
							const items = [ ...section.children ].filter(
								( item ) =>
									! item.hasAttribute( 'hidden' ) &&
									! item.matches(
										'.case-studies-slider__featured-image-media'
									)
							);

							items.forEach( ( item ) => {
								item.style.removeProperty( 'transition' );
								item.style.removeProperty( 'opacity' );
								item.style.removeProperty( 'transform' );
							} );

							if (
								section.matches(
									'[data-component-list*="StaggeredFadeIn"]'
								)
							) {
								section.classList.add( 'staggered-end' );
							}
						} );

					window.requestAnimationFrame(() => {
						slider.classList.remove('is-metric-entering', 'is-animating');
					});
				}, 40 );
			});
		});
	}, metricDelay);

	return nextIndex;
}

function initCaseStudiesSlider(wrapper) {
	const dataNode = wrapper.querySelector('.case-studies-slider__data');
	const slider = wrapper.querySelector('.case-studies-slider');

	if (!dataNode || !slider) {
		return;
	}

	let posts = [];

	try {
		posts = JSON.parse(dataNode.textContent || '[]');
	} catch (error) {
		return;
	}

	if (!Array.isArray(posts) || !posts.length) {
		return;
	}

	let currentIndex = getInitialCenterIndex(posts.length);

	renderCaseStudiesState(slider, posts, currentIndex);

	const previousButton = slider.querySelector('.case-studies-slider__nav--prev');
	const nextButton = slider.querySelector('.case-studies-slider__nav--next');

	previousButton?.addEventListener('click', (event) => {
		event.preventDefault();
		const nextIndex = wrapIndex(currentIndex - 1, posts.length);
		const updatedIndex = animateCaseStudiesTransition(
			slider,
			posts,
			nextIndex
		);

		if (updatedIndex !== null) {
			currentIndex = updatedIndex;
		}
	});

	nextButton?.addEventListener('click', (event) => {
		event.preventDefault();
		const nextIndex = wrapIndex(currentIndex + 1, posts.length);
		const updatedIndex = animateCaseStudiesTransition(
			slider,
			posts,
			nextIndex
		);

		if (updatedIndex !== null) {
			currentIndex = updatedIndex;
		}
	});
}

document.querySelectorAll('.case-studies-slider-wrapper').forEach(initCaseStudiesSlider);
